// extracted by mini-css-extract-plugin
module.exports = {"container":"container__1VpkF","section":"section__2uB7a","iconText":"iconText__PAYA7"};